<template>
    <el-result title="404">
      <template #icon>
        <div style="width: 250px; height: 295px; margin: 20px 0 10px 0">
          <icon-svg />
        </div>
      </template>
      <template #title>
        <p>抱歉, 你访问的页面不存在.</p>
      </template>
      <template #extra>
        <router-link to="/" style="display: inline-flex; text-decoration: none">
          <el-button type="primary" @click="goHome">返回首页</el-button>
        </router-link>
      </template>
    </el-result>
</template>

<script setup>
  import IconSvg from './components/icon-svg.vue';
  let body = document.getElementsByTagName('body')[0];
  let className = body.className.trim().split(' ').filter((d) => d !== '');
  className.push('state-error');
  body.className = className.join(' ');
  const goHome = () => {
    className = className.filter((d) => d !== 'state-error');
    body.className = className.join(' ');
  };
</script>

<style scoped>
body {
  width: 100%;
  min-width: 100%;
}
</style>